import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { WebClientSize } from "@faire/web-api--source/indigofair/data/WebClientSize";
export var useGetCurrentSDUIClientSize = function() {
    var v = useViewport();
    if (v.isMobile) {
        return WebClientSize.MOBILE;
    } else if (v.isTablet) {
        return WebClientSize.TABLET;
    } else if (v.isDesktop) {
        return WebClientSize.DESKTOP;
    } else if (v.isXLargeAndAbove) {
        return WebClientSize.XLARGE_DESKTOP;
    } else {
        return WebClientSize.WEB_CLIENT_SIZE_UNKNOWN;
    }
};
